import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable/types/skyNetTable.types'
import {
    OrderStatuses,
    OrderTypes,
    ProductType,
} from 'app/enums/label.enums'

import {
    FilterType,
} from 'app/enums/common.enums'

import {
    TruckingCapacityOutbound,
} from './relatedOrders.types'

const config: SkyNetTableConfig<keyof TruckingCapacityOutbound> = {

    name: 'RelatedOrders-OutboundOrder',
    fields: [
        {
            name: 'orderNumber',
            width: '160px',
            componentName: 'OrderTableLink',
            labelKey: 'ORDER',
        },
        {
            name: 'orderStatus',
            componentName: 'EnumValue',
            allowedValuesEnum: OrderStatuses,
            labelKey: 'ORDER_STATUS',
        },
        {
            name: 'orderType',
            componentName: 'EnumValue',
            allowedValuesEnum: OrderTypes,
            labelKey: 'ORDER_TYPE',
            filterField: 'orderType',
            filterType: FilterType.Array,
        },
        {
            name: 'from',
            labelKey: 'FROM',
        },
        {
            name: 'to',
            labelKey: 'TO',
        },
        {
            name: 'customerLocationName',
            labelKey: 'CUSTOMER',
        },
        {
            name: 'pricingAccountCompanyName',
            labelKey: 'PRICING_ACCOUNT',
        },
        {
            name: 'estimatedDelivery',
            sorting: false,
            labelKey: 'ESTIMATED_PICK-UP',
        },
        {
            name: 'requiredContainers',
            componentName: 'RequiredContainersList',
            allowedValuesEnum: ProductType,
            sorting: false,
            labelKey: 'REQUIRED_CONTAINERS',
            filterField: 'requiredContainers',
            filterType: FilterType.Array,
        },
    ],
}

export default config
